/* eslint-disable max-len */
import { DOCUMENT } from '@angular/common';
import { Directive, Input, AfterViewInit, SimpleChanges, OnChanges, ElementRef, Inject } from '@angular/core';

const spinnerTpl = `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:100%">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M90.839 55.9743C90.9699 55.072 91.0715 54.1602 91.143 53.2399C91.2261 52.1705 91.2684 51.0896 91.2684 49.9988C91.2684 48.9081 91.2261 47.8272 91.143 46.7578C91.0715 45.8375 90.9699 44.9257 90.839 44.0234C90.7065 43.1096 90.544 42.2055 90.3526 41.3122C87.5077 41.7223 85.4313 44.2769 85.6571 47.184C85.7292 48.1117 85.766 49.0505 85.766 49.9988C85.766 50.9472 85.7292 51.8859 85.6571 52.8137C85.4313 55.7208 87.5077 58.2754 90.3526 58.6855C90.544 57.7922 90.7065 56.8881 90.839 55.9743ZM84.6716 72.3901C82.369 70.669 79.094 71.0087 77.1991 73.2253C73.5566 77.4862 68.9345 80.8779 63.6894 83.053C60.997 84.1695 59.6616 87.1767 60.5841 89.8974C61.4755 89.6616 62.3551 89.3967 63.2218 89.1037C64.0936 88.809 64.9524 88.486 65.7971 88.1358C71.8546 85.6238 77.1841 81.7108 81.3815 76.8008C81.9772 76.104 82.5501 75.3872 83.099 74.6514C83.6475 73.9162 84.1721 73.162 84.6716 72.3901ZM58.6867 90.3514C58.2767 87.5064 55.722 85.4301 52.815 85.6559C51.8872 85.728 50.9485 85.7648 50.0001 85.7648C49.0517 85.7648 48.113 85.728 47.1852 85.6559C44.2781 85.4301 41.7235 87.5064 41.3134 90.3514C42.2067 90.5428 43.1108 90.7052 44.0246 90.8378C44.9269 90.9687 45.8387 91.0703 46.759 91.1418C47.8284 91.2249 48.9093 91.2672 50.0001 91.2672C51.0908 91.2672 52.1717 91.2249 53.2411 91.1418C54.1614 91.0703 55.0732 90.9687 55.9756 90.8378C56.8893 90.7052 57.7934 90.5428 58.6867 90.3514ZM27.6088 84.6704C29.33 82.3678 28.9902 79.0928 26.7736 77.1979C22.5127 73.5554 19.121 68.9332 16.9459 63.6881C15.8294 60.9957 12.8222 59.6604 10.1015 60.5828C10.3373 61.4743 10.6023 62.3538 10.8952 63.2205C11.1899 64.0924 11.5129 64.9512 11.8632 65.7959C14.3751 71.8533 18.2882 77.1829 23.1981 81.3803C23.8949 81.976 24.6117 82.5489 25.3475 83.0978C26.0828 83.6463 26.8369 84.1709 27.6088 84.6704ZM9.64753 58.6855C12.4925 58.2754 14.5689 55.7208 14.343 52.8137C14.2709 51.8859 14.2341 50.9472 14.2341 49.9988C14.2341 49.0505 14.2709 48.1117 14.343 47.184C14.5689 44.2769 12.4925 41.7223 9.64753 41.3122C9.45614 42.2055 9.29367 43.1096 9.16114 44.0234C9.03026 44.9257 8.92858 45.8375 8.85709 46.7578C8.77401 47.8272 8.73169 48.9081 8.73169 49.9988C8.73169 51.0896 8.77401 52.1705 8.85709 53.2399C8.92858 54.1602 9.03026 55.072 9.16114 55.9743C9.29367 56.8881 9.45614 57.7922 9.64753 58.6855ZM15.3285 27.6076C17.6311 29.3287 20.9061 28.989 22.801 26.7724C26.4435 22.5115 31.0657 19.1197 36.3108 16.9447C39.0032 15.8282 40.3385 12.821 39.4161 10.1003C38.5247 10.3361 37.6451 10.601 36.7784 10.894C35.9065 11.1886 35.0477 11.5117 34.203 11.8619C28.1456 14.3739 22.816 18.2869 18.6186 23.1969C18.0229 23.8937 17.4501 24.6105 16.9012 25.3463C16.3526 26.0815 15.828 26.8357 15.3285 27.6076ZM41.3134 9.64631C41.7235 12.4912 44.2781 14.5676 47.1852 14.3418C48.113 14.2697 49.0517 14.2329 50.0001 14.2329C50.9485 14.2329 51.8872 14.2697 52.815 14.3418C55.722 14.5676 58.2767 12.4912 58.6867 9.64631C57.7934 9.45492 56.8893 9.29245 55.9755 9.15992C55.0732 9.02904 54.1614 8.92736 53.2411 8.85587C52.1717 8.77279 51.0908 8.73047 50.0001 8.73047C48.9093 8.73047 47.8284 8.77279 46.759 8.85587C45.8387 8.92736 44.9269 9.02904 44.0246 9.15992C43.1108 9.29245 42.2067 9.45492 41.3134 9.64631ZM89.8987 39.4149C89.6628 38.5234 89.3979 37.6438 89.1049 36.7772C88.8103 35.9053 88.4872 35.0465 88.137 34.2018C85.6251 28.1444 81.712 22.8148 76.802 18.6174C76.1053 18.0217 75.3884 17.4488 74.6526 16.8999C73.9174 16.3514 73.1632 15.8268 72.3913 15.3273C70.6702 17.6299 71.0099 20.9049 73.2265 22.7998C77.4874 26.4423 80.8792 31.0645 83.0542 36.3095C84.1707 39.002 87.1779 40.3373 89.8987 39.4149Z" fill="url(#paint0_linear_4809_22358)" />
        <defs>
            <linearGradient id="paint0_linear_4809_22358" x1="8.73169" y1="18.1878" x2="92.144" y2="23.5047" gradientUnits="userSpaceOnUse">
                <stop stop-color="#C2C8FF" />
                <stop offset="1" stop-color="#B2E8FE" />
            </linearGradient>
        </defs>
    </svg>
`;

@Directive({
    selector: '[appLoading]',
})
export class LoadingDirective implements AfterViewInit, OnChanges {
    @Input() loading: boolean;
    @Input() maskVisible: boolean;

    private boxNode: HTMLElement;

    constructor(private el: ElementRef<HTMLDivElement>, @Inject(DOCUMENT) private document: Document) {}

    ngOnChanges(e: SimpleChanges) {
        if (!e?.loading.firstChange) {
            if (this.loading) {
                this.showLoading();
            } else {
                this.hideLoading();
            }
        }
    }

    ngAfterViewInit() {
        if (this.loading) {
            this.showLoading();
        }
    }

    showLoading() {
        if (!this.el.nativeElement.style.position || this.el.nativeElement.style.position === 'static') {
            this.el.nativeElement.style.position = 'relative';
        }

        this.boxNode = this.el.nativeElement.querySelector('.loading-directive-div') || this.document.createElement('div');
        this.boxNode.classList.add('loading-directive-div');
        this.boxNode.style.width = '100%';
        this.boxNode.style.height = '100%';
        this.boxNode.style.display = 'flex';
        this.boxNode.style.justifyContent = 'center';
        this.boxNode.style.alignItems = 'center';
        this.boxNode.style.position = 'absolute';
        this.boxNode.style.left = '0';
        this.boxNode.style.top = '0';
        this.boxNode.style.zIndex = '999';
        if (this.maskVisible) {
            this.boxNode.style.background = 'rgba(255,255,255,0.1)';
        }

        const imgContainer = this.document.createElement('div');
        imgContainer.innerHTML = spinnerTpl;
        imgContainer.style.width = '40px';
        imgContainer.style.height = '40px';
        imgContainer.style.maxWidth = '100%';
        imgContainer.style.maxHeight = '100%';
        imgContainer.style.objectFit = 'contain';
        imgContainer.style.animation = 'spin 2s linear infinite';

        this.boxNode.appendChild(imgContainer);

        this.el.nativeElement.append(this.boxNode);
    }

    hideLoading() {
        this.boxNode.style.opacity = '0';
        setTimeout(() => {
            this.boxNode.remove();
        }, 500);
    }
}
